import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { VesselCaptainMap } from 'anchor-shared/lib/model/entity/vesselCaptainMap';

@Injectable()
export class VesselCaptainMapDAO extends BaseDAO<VesselCaptainMap> {
  static PATHS = {
    VESSEL: '/vessels',
  };

  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.VESSEL_CAPTAIN);
  }

  public getVesselsByCaptainId(captainId?: number): Observable<any[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      VesselCaptainMapDAO.PATHS.VESSEL +
      '/' +
      captainId;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let httpRequest: Observable<VesselCaptainMap[]> = this.apiHelper.apiCall<
      VesselCaptainMap[]
    >(url, method, null, null, headers);

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (vessels: VesselCaptainMap[]) => {
          observer.next(vessels);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }
}
